module.exports = __webpack_public_path__ + "img/enterprise_banner2.a4de69dc.png";